export type ReviewSourceDisplay = {
  label: string;
  iconClass: string | null;
  /** Rounded badge behind the icon; null when there is no icon */
  iconBackground: string | null;
};

const REVIEW_ORIGIN_CONFIG: Record<
  string,
  { label: string; iconClass: string; iconBackground: string }
> = {
  airbnb: {
    label: 'Airbnb',
    iconClass: 'icon-[simple-icons--airbnb] bg-[#fff]',
    iconBackground: '#ff5a5f',
  },
  vrbo: {
    label: 'Vrbo',
    iconClass: 'icon-[arcticons--vrbo] text-white',
    iconBackground: '#245ABC',
  },
};

function formatUnknownSource(source: string): string {
  const trimmed = source.trim();
  if (!trimmed) {
    return source;
  }
  return trimmed
    .split(/[\s_-]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export function getReviewSourceDisplay(source: string): ReviewSourceDisplay {
  const key = source.trim().toLowerCase();
  const known = REVIEW_ORIGIN_CONFIG[key];
  if (known) {
    return {
      label: known.label,
      iconClass: known.iconClass,
      iconBackground: known.iconBackground,
    };
  }
  return {
    label: formatUnknownSource(source),
    iconClass: null,
    iconBackground: null,
  };
}
